let houserecovery = [
  {
    path: '/houserecovery_index',
    name: '新闻里主页',
    component: () => import('@/pages/houserecovery/houserecovery_index')
  },
  {
    path: '/houserecovery_bedreservation',
    name: '床位预约',
    component: () => import('@/pages/houserecovery/houserecovery_bedreservation')
  },
  {
    path: '/houserecovery_hrecovery',
    name: '居家康复',
    component: () => import('@/pages/houserecovery/houserecovery_hrecovery')
  },
  {
    path: '/houserecovery_hrecoverydetail',
    name: '居家康复',
    component: () => import('@/pages/houserecovery/houserecovery_hrecoverydetail')
  },
  {
    path: '/houserecovery_bedreservation_orderdetail',
    name: '订单详情',
    component: () => import('@/pages/houserecovery/houserecovery_bedreservation_orderdetail')
  },
  {
    path: '/houserecovery_minelist',
    name: '康复养老',
    component: () => import('@/pages/houserecovery/houserecovery_minelist')
  },
  {
    path: '/houserecovery_minelist_bed_detail',
    name: '订单详情',
    component: () => import('@/pages/houserecovery/houserecovery_minelist_bed_detail')
  },
  {
    path: '/houserecovery_minelist_combo_detail',
    name: '订单详情',
    component: () => import('@/pages/houserecovery/houserecovery_minelist_combo_detail')
  },
  {
    path: '/houserecovery_fillinfo',
    name: '填写资料',
    component: () => import('@/pages/houserecovery/houserecovery_fillinfo')
  },
  {
    path: '/houserecovery_hrecovery_orderdetail',
    name: '订单详情',
    component: () => import('@/pages/houserecovery/houserecovery_hrecovery_orderdetail')
  },
  {
    path: '/houserecovery_changecombo',
    name: '更换套餐',
    component: () => import('@/pages/houserecovery/houserecovery_changecombo')
  },
  {
    path: '/houserecovery_insurance',
    name: '长护险代办',
    component: () => import('@/pages/houserecovery/houserecovery_insurance')
  },
  {
    path: '/houserecovery_insurance_center',
    name: '养老服务平台',
    component: () => import('@/pages/houserecovery/houserecovery_insurance_center')
  },
  {
    path: '/houserecovery_insurance_center_new',
    name: '养老服务平台',
    component: () => import('@/pages/houserecovery/houserecovery_insurance_center_new')
  },
  {
    path: '/houserecovery_insurance_apply',
    name: '长护险代办申请',
    component: () => import('@/pages/houserecovery/houserecovery_insurance_apply')
  },
  {
    path: '/houserecovery_insurance_submit',
    name: '上传成功',
    component: () => import('@/pages/houserecovery/houserecovery_insurance_submit')
  },
  {
    path: '/houserecovery_kunhua_packages',
    name: '床位列表',
    component: () => import('@/pages/houserecovery/houserecovery_kunhua_packages')
  },
  {
    path: '/houserecovery_introduce',
    name: '床位介绍',
    component: () => import('@/pages/houserecovery/houserecovery_introduce')
  }
]

export default houserecovery
